export default __webpack_public_path__ + "static/media/filter.c2d153fd.svg";